import script from "./scene-price-mgmt-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./scene-price-mgmt-list.vue?vue&type=script&lang=tsx&setup=true"

import "./scene-price-mgmt-list.vue?vue&type=style&index=0&id=d9171fa6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9171fa6"]])

export default __exports__